import Head from 'next/head'

import { env } from '@/shared/config'
import { getAssetUrl } from '@/shared/lib/cdn'
import type { Translation } from '@/shared/lib/i18n'

export function AppHead(props: { i18n: Translation }) {
    const { i18n } = props

    return (
        <Head>
            <title>{i18n.PORTAL_TITLE}</title>
            <meta name="description" content={i18n.PORTAL_META_DESCR} />
            <link rel="icon" type="image/png" href={getAssetUrl('/assets/icon/favicon-192x192.png')} sizes="192x192" />
            <link rel="icon" type="image/png" href={getAssetUrl('/assets/icon/favicon-48x48.png')} sizes="48x48" />
            <link rel="icon" type="image/svg+xml" href={getAssetUrl('/assets/icon/favicon.svg')} />
            <link rel="shortcut icon" href={getAssetUrl('/assets/icon/favicon.ico')} />
            <link rel="apple-touch-icon" sizes="180x180" href={getAssetUrl('/assets/icon/apple-touch-icon.png')} />
            <meta name="version" content={env.BUILD_VERSION} />

            <meta name="apple-mobile-web-app-title" content="Taonga" />
            <meta name="theme-color" content="#9dd7c6" />

            <meta name="og:title" content={i18n.PORTAL_TITLE} />
            <meta name="og:description" content={i18n.PORTAL_META_DESCR} />
            <meta name="og:image" content={getAssetUrl('/assets/island-map-og.webp')} />
            <meta property="og:image:alt" content="Taonga Farm" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta name="og:type" content="website" />

            <link rel="manifest" href="/manifest.json" />
        </Head>
    )
}
